import { AssetGroupType } from '@x-guard/xgac-types/xgac';
import authProvider from './authProvider';

const assetHasApp = (asset: object): boolean => {

  if (!('app' in asset)) return false;
  return (asset as { app?: unknown }).app != null;

};

// Same rule as the alarm app: people groups only contain app users, hardware groups only assets without an app.
export const assetMatchesGroupType = (asset: object, groupType?: string | null): boolean => {

  if (groupType === AssetGroupType.People) return assetHasApp(asset);
  if (groupType === AssetGroupType.Hardware) return !assetHasApp(asset);
  return true;

};

const isSimulatingCustomerAdmin = (): boolean => sessionStorage.getItem('simulateCustomerAdmin') === 'true';

export const restrictAssetGroupMembers = (): boolean => {

  if (isSimulatingCustomerAdmin()) return true;
  if (authProvider.isAdmin() || authProvider.isDeveloperAdmin()) return false;
  const roles = authProvider.getRoles();
  return roles.includes('customer_admin') || roles.includes('bhvk_admin');

};

export const showAssetGroupTypeMismatch = (): boolean => (
  !isSimulatingCustomerAdmin() && (authProvider.isAdmin() || authProvider.isDeveloperAdmin())
);

export const assetGroupMemberListFilter = (groupType?: string | null): { app: string } | undefined => {

  if (!restrictAssetGroupMembers()) return undefined;
  if (groupType === AssetGroupType.People) return { app: '!null' };
  if (groupType === AssetGroupType.Hardware) return { app: 'null' };
  return undefined;

};
